<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper worldEndedModal" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal simple worldEndedModal" style="top: 0;">
				<div class="modalContent">
					<div ng-controller="worldEndedSummaryCtrl">
						<div @click="onGotoWorldEnded(close)" clickable="openWindow('worldEnded')" ng-class="{'disabled':gameworld.data.data.endgameCalculationsRunning==1}" class="clickable">
							<div class="headerBackground">
								<div class="worldWonder"></div>
							</div>
							<div class="winnerKingdom endOfWorld_winnerKingdom_large_illu"></div>
							<div class="textBox">
								<h2 data="wwBuilderName:Медоеды" translate=""><span>Медоеды завершил строительство Чуда Света!</span></h2>
								<div class="horizontalLine"></div>
								<!-- ngIf: gameworld.data.data.endgameCalculationsRunning==1 -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onGotoWorldEnded(close){
			this.$router.push({path: '/world-ended'});
			this.onModalClose(close);
		},
		
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>